export interface Language {
  code: string;       // ISO 639-1
  name: string;       // native name in native script
  nameEn: string;     // English name
  flag: string;       // flag emoji of most associated country
  isTop10: boolean;
}

// Top 10 by number of speakers
export const languages: Language[] = [
  // --- TOP 10 (bigger font, shown first) ---
  { code: 'ar', name: 'العربية', nameEn: 'Arabic', flag: '🇸🇦', isTop10: true },
  { code: 'bn', name: 'বাংলা', nameEn: 'Bengali', flag: '🇧🇩', isTop10: true },
  { code: 'en', name: 'English', nameEn: 'English', flag: '🇬🇧', isTop10: true },
  { code: 'es', name: 'Español', nameEn: 'Spanish', flag: '🇪🇸', isTop10: true },
  { code: 'fr', name: 'Français', nameEn: 'French', flag: '🇫🇷', isTop10: true },
  { code: 'hi', name: 'हिन्दी', nameEn: 'Hindi', flag: '🇮🇳', isTop10: true },
  { code: 'ja', name: '日本語', nameEn: 'Japanese', flag: '🇯🇵', isTop10: true },
  { code: 'pt', name: 'Português', nameEn: 'Portuguese', flag: '🇧🇷', isTop10: true },
  { code: 'ru', name: 'Русский', nameEn: 'Russian', flag: '🇷🇺', isTop10: true },
  { code: 'zh', name: '中文', nameEn: 'Chinese', flag: '🇨🇳', isTop10: true },

  // --- REMAINING (alphabetical by English name, smaller font) ---
  { code: 'af', name: 'Afrikaans', nameEn: 'Afrikaans', flag: '🇿🇦', isTop10: false },
  { code: 'sq', name: 'Shqip', nameEn: 'Albanian', flag: '🇦🇱', isTop10: false },
  { code: 'am', name: 'አማርኛ', nameEn: 'Amharic', flag: '🇪🇹', isTop10: false },
  { code: 'hy', name: 'Հայերեն', nameEn: 'Armenian', flag: '🇦🇲', isTop10: false },
  { code: 'az', name: 'Azərbaycanca', nameEn: 'Azerbaijani', flag: '🇦🇿', isTop10: false },
  { code: 'eu', name: 'Euskara', nameEn: 'Basque', flag: '🇪🇸', isTop10: false },
  { code: 'be', name: 'Беларуская', nameEn: 'Belarusian', flag: '🇧🇾', isTop10: false },
  { code: 'bs', name: 'Bosanski', nameEn: 'Bosnian', flag: '🇧🇦', isTop10: false },
  { code: 'bg', name: 'Български', nameEn: 'Bulgarian', flag: '🇧🇬', isTop10: false },
  { code: 'my', name: 'မြန်မာဘာသာ', nameEn: 'Burmese', flag: '🇲🇲', isTop10: false },
  { code: 'ca', name: 'Català', nameEn: 'Catalan', flag: '🇪🇸', isTop10: false },
  { code: 'ceb', name: 'Cebuano', nameEn: 'Cebuano', flag: '🇵🇭', isTop10: false },
  { code: 'hr', name: 'Hrvatski', nameEn: 'Croatian', flag: '🇭🇷', isTop10: false },
  { code: 'cs', name: 'Čeština', nameEn: 'Czech', flag: '🇨🇿', isTop10: false },
  { code: 'da', name: 'Dansk', nameEn: 'Danish', flag: '🇩🇰', isTop10: false },
  { code: 'nl', name: 'Nederlands', nameEn: 'Dutch', flag: '🇳🇱', isTop10: false },
  { code: 'et', name: 'Eesti', nameEn: 'Estonian', flag: '🇪🇪', isTop10: false },
  { code: 'fa', name: 'فارسی', nameEn: 'Farsi', flag: '🇮🇷', isTop10: false },
  { code: 'fi', name: 'Suomi', nameEn: 'Finnish', flag: '🇫🇮', isTop10: false },
  { code: 'ka', name: 'ქართული', nameEn: 'Georgian', flag: '🇬🇪', isTop10: false },
  { code: 'de', name: 'Deutsch', nameEn: 'German', flag: '🇩🇪', isTop10: false },
  { code: 'el', name: 'Ελληνικά', nameEn: 'Greek', flag: '🇬🇷', isTop10: false },
  { code: 'gu', name: 'ગુજરાતી', nameEn: 'Gujarati', flag: '🇮🇳', isTop10: false },
  { code: 'ht', name: 'Kreyòl', nameEn: 'Haitian Creole', flag: '🇭🇹', isTop10: false },
  { code: 'ha', name: 'Hausa', nameEn: 'Hausa', flag: '🇳🇬', isTop10: false },
  { code: 'he', name: 'עברית', nameEn: 'Hebrew', flag: '🇮🇱', isTop10: false },
  { code: 'hu', name: 'Magyar', nameEn: 'Hungarian', flag: '🇭🇺', isTop10: false },
  { code: 'is', name: 'Íslenska', nameEn: 'Icelandic', flag: '🇮🇸', isTop10: false },
  { code: 'ig', name: 'Igbo', nameEn: 'Igbo', flag: '🇳🇬', isTop10: false },
  { code: 'id', name: 'Bahasa Indonesia', nameEn: 'Indonesian', flag: '🇮🇩', isTop10: false },
  { code: 'ga', name: 'Gaeilge', nameEn: 'Irish', flag: '🇮🇪', isTop10: false },
  { code: 'it', name: 'Italiano', nameEn: 'Italian', flag: '🇮🇹', isTop10: false },
  { code: 'jv', name: 'Basa Jawa', nameEn: 'Javanese', flag: '🇮🇩', isTop10: false },
  { code: 'kn', name: 'ಕನ್ನಡ', nameEn: 'Kannada', flag: '🇮🇳', isTop10: false },
  { code: 'kk', name: 'Қазақша', nameEn: 'Kazakh', flag: '🇰🇿', isTop10: false },
  { code: 'km', name: 'ខ្មែរ', nameEn: 'Khmer', flag: '🇰🇭', isTop10: false },
  { code: 'ko', name: '한국어', nameEn: 'Korean', flag: '🇰🇷', isTop10: false },
  { code: 'ku', name: 'Kurdî', nameEn: 'Kurdish', flag: '🇮🇶', isTop10: false },
  { code: 'ky', name: 'Кыргызча', nameEn: 'Kyrgyz', flag: '🇰🇬', isTop10: false },
  { code: 'lo', name: 'ລາວ', nameEn: 'Lao', flag: '🇱🇦', isTop10: false },
  { code: 'lv', name: 'Latviešu', nameEn: 'Latvian', flag: '🇱🇻', isTop10: false },
  { code: 'lt', name: 'Lietuvių', nameEn: 'Lithuanian', flag: '🇱🇹', isTop10: false },
  { code: 'mk', name: 'Македонски', nameEn: 'Macedonian', flag: '🇲🇰', isTop10: false },
  { code: 'mg', name: 'Malagasy', nameEn: 'Malagasy', flag: '🇲🇬', isTop10: false },
  { code: 'ms', name: 'Bahasa Melayu', nameEn: 'Malay', flag: '🇲🇾', isTop10: false },
  { code: 'ml', name: 'മലയാളം', nameEn: 'Malayalam', flag: '🇮🇳', isTop10: false },
  { code: 'mt', name: 'Malti', nameEn: 'Maltese', flag: '🇲🇹', isTop10: false },
  { code: 'mr', name: 'मराठी', nameEn: 'Marathi', flag: '🇮🇳', isTop10: false },
  { code: 'mn', name: 'Монгол', nameEn: 'Mongolian', flag: '🇲🇳', isTop10: false },
  { code: 'ne', name: 'नेपाली', nameEn: 'Nepali', flag: '🇳🇵', isTop10: false },
  { code: 'no', name: 'Norsk', nameEn: 'Norwegian', flag: '🇳🇴', isTop10: false },
  { code: 'or', name: 'ଓଡ଼ିଆ', nameEn: 'Odia', flag: '🇮🇳', isTop10: false },
  { code: 'ps', name: 'پښتو', nameEn: 'Pashto', flag: '🇦🇫', isTop10: false },
  { code: 'pl', name: 'Polski', nameEn: 'Polish', flag: '🇵🇱', isTop10: false },
  { code: 'pa', name: 'ਪੰਜਾਬੀ', nameEn: 'Punjabi', flag: '🇮🇳', isTop10: false },
  { code: 'ro', name: 'Română', nameEn: 'Romanian', flag: '🇷🇴', isTop10: false },
  { code: 'rw', name: 'Kinyarwanda', nameEn: 'Rwandan', flag: '🇷🇼', isTop10: false },
  { code: 'sr', name: 'Српски', nameEn: 'Serbian', flag: '🇷🇸', isTop10: false },
  { code: 'si', name: 'සිංහල', nameEn: 'Sinhala', flag: '🇱🇰', isTop10: false },
  { code: 'sk', name: 'Slovenčina', nameEn: 'Slovak', flag: '🇸🇰', isTop10: false },
  { code: 'sl', name: 'Slovenščina', nameEn: 'Slovenian', flag: '🇸🇮', isTop10: false },
  { code: 'so', name: 'Soomaali', nameEn: 'Somali', flag: '🇸🇴', isTop10: false },
  { code: 'sw', name: 'Kiswahili', nameEn: 'Swahili', flag: '🇰🇪', isTop10: false },
  { code: 'sv', name: 'Svenska', nameEn: 'Swedish', flag: '🇸🇪', isTop10: false },
  { code: 'tl', name: 'Tagalog', nameEn: 'Tagalog', flag: '🇵🇭', isTop10: false },
  { code: 'tg', name: 'Тоҷикӣ', nameEn: 'Tajik', flag: '🇹🇯', isTop10: false },
  { code: 'ta', name: 'தமிழ்', nameEn: 'Tamil', flag: '🇮🇳', isTop10: false },
  { code: 'te', name: 'తెలుగు', nameEn: 'Telugu', flag: '🇮🇳', isTop10: false },
  { code: 'th', name: 'ไทย', nameEn: 'Thai', flag: '🇹🇭', isTop10: false },
  { code: 'tr', name: 'Türkçe', nameEn: 'Turkish', flag: '🇹🇷', isTop10: false },
  { code: 'tk', name: 'Türkmen', nameEn: 'Turkmen', flag: '🇹🇲', isTop10: false },
  { code: 'uk', name: 'Українська', nameEn: 'Ukrainian', flag: '🇺🇦', isTop10: false },
  { code: 'ur', name: 'اردو', nameEn: 'Urdu', flag: '🇵🇰', isTop10: false },
  { code: 'uz', name: 'Oʻzbekcha', nameEn: 'Uzbek', flag: '🇺🇿', isTop10: false },
  { code: 'vi', name: 'Tiếng Việt', nameEn: 'Vietnamese', flag: '🇻🇳', isTop10: false },
  { code: 'cy', name: 'Cymraeg', nameEn: 'Welsh', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿', isTop10: false },
  { code: 'xh', name: 'isiXhosa', nameEn: 'Xhosa', flag: '🇿🇦', isTop10: false },
  { code: 'yo', name: 'Yorùbá', nameEn: 'Yoruba', flag: '🇳🇬', isTop10: false },
  { code: 'zu', name: 'isiZulu', nameEn: 'Zulu', flag: '🇿🇦', isTop10: false },
];

export const topLanguages = languages.filter(l => l.isTop10).sort((a, b) => a.nameEn.localeCompare(b.nameEn));
export const otherLanguages = languages.filter(l => !l.isTop10).sort((a, b) => a.nameEn.localeCompare(b.nameEn));

export function getLanguageByCode(code: string): Language | undefined {
  return languages.find(l => l.code === code);
}
